import R from 'ramda';

export const toggle = (value, values) => {
  if (R.contains(value, values)) {
    return R.without(value, values);
  } else {
    return R.append(value, values);
  }
};

export { normalizeOptions } from '../../utils';
